var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-inline-input',_vm._b({staticClass:"pt-1",class:{'pb-3': !_vm.schema.noPadding},attrs:{"state":_vm.state,"validationMessage":_vm.validationMessage},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'n-inline-input',_vm.schema,false))
}
var staticRenderFns = []

export { render, staticRenderFns }